<script>
import FadeSlideUp from '@/components/transitions/FadeSlideUp'

export default {
	components: { FadeSlideUp },
  props: {
    imgSrc: { type: String, required: true },
    title: { type: String, required: true },
		description: { type: String, required: true },
		new: { type: Boolean, required: false },
		center: { type: Boolean, required: false },
  },
}
</script>

<template>
	<FadeSlideUp>
		<li
			:class="[
				'flex flex-col list-none',
				center ? 'items-center' : 'items-start',
			]"
		>
			<img
				:src="imgSrc"
				alt=""
				style="height: 100px;"
			/>
			<div
				:class="[
					'mt-8 flex flex-wrap items-center',
					center && 'justify-center',
				]"
				style="column-gap: 10px; row-gap: 6px;"
			>
				<h3
					:class="[
						'font-header text-grey-700 font-semibold leading-tight text-pretty',
						center && 'text-center'
					]"
					style="font-size: 28px;"
				>{{ title }}</h3>
				<span
					v-if="$props.new"
					class="py-1 px-3 bg-green rounded-full font-header font-bold leading-tight text-white uppercase"
					style="font-size: 13px;"
				>New</span>
			</div>
			<p
				:class="[
					'text-base leading-tight',
					center && 'text-center'
				]"
				style="color: #67615F; margin-top: 10px;"
			>{{ description }}</p>
		</li>
	</FadeSlideUp>
</template>
